import { MenuItem } from "@blueprintjs/core";
import { ItemPredicate, ItemRenderer, Select } from "@blueprintjs/select";
import * as React from "react";
import { IProdutoGenerico } from "../../model";

export const ProdutoGenericoSelect = Select.ofType<IProdutoGenerico>();

export const filterProduto: ItemPredicate<IProdutoGenerico> = (query, produto) => {
  return produto.descricao.toLowerCase().indexOf(query.toLowerCase()) >= 0;
};

export const returnLabel = (produto: IProdutoGenerico) => {
  let new_label = ""
  if (produto.cest != "") {
    new_label += `CEST: ${produto.cest}`
  }

  if (produto.ncm != "" && new_label != "") {
    new_label += ` - NCM: ${produto.ncm}`
  }
  
  if (produto.ncm != "" && new_label == "") {
    new_label += `NCM: ${produto.ncm}`
  }

  return new_label
}

export const renderProduto: ItemRenderer<IProdutoGenerico> = (produto, { handleClick, modifiers }) => {
  if (!modifiers.matchesPredicate) {
    return null;
  }
  return (
    <MenuItem
      active={modifiers.active}
      key={produto.id}
      text={produto.descricao}
      onClick={handleClick}
      label={returnLabel(produto)}
    />
  );
};
